import { API_KEY } from "./constants/constants";
export const originals = `discover/tv?api_key=${API_KEY}&with_networks=213`;

export const action = `discover/movie?api_key=${API_KEY}&with_genres=28`;

export const history = `discover/movie?api_key=${API_KEY}&with_genres=36`;

export const horror = `discover/movie?api_key=${API_KEY}&with_genres=27`;

export const animation = `discover/movie?api_key=${API_KEY}&with_genres=16`;

export const documentary = `discover/movie?api_key=${API_KEY}&with_genres=99`;
